/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/

// @mui material components
import { Card } from '@mui/material'
import Grid from '@mui/material/Grid'

// MD UI Dashboard PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// MD UI Dashboard PRO React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import AppData from './components/data-tables/data/dataTableData'
import { useEffect } from 'react'
import Loader from 'examples/Loader'
import DataTable from './components/DataTable'

function Default() {
  const {
    loader,
    dataTableData,
    handleRefresh,
    pagination,
    handlePageChange,
    handleLimitChange,
    getGhlLocations,
    handleDownloadCSV,
    exportloading
  } = AppData()

  useEffect(() => {
    // Any initial load logic
  }, [])

  return (
    <DashboardLayout>
      {loader ? (
        <Loader />
      ) : (
        <>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" color="white">
                      App Installation
                    </MDTypography>
                  </MDBox>
                  <MDBox pt={3} px={3}>
                    <DataTable
                      table={dataTableData}
                      canSearch
                      onSearch={(query) => {
                        getGhlLocations(1, pagination.limit, query) // pass search string
                      }}
                      onDownload={handleDownloadCSV}
                      entriesPerPage={{
                        defaultValue: pagination?.limit || 50,
                        entries: [10, 25, 50, 100],
                      }}
                      exportloading={exportloading}
                      showTotalEntries={pagination?.total || 0}
                      pagination={{
                        variant: 'gradient',
                        color: 'info',
                        pageCount: pagination?.totalPages || 1,
                        pageIndex: (pagination?.page || 1) - 1, // Convert to 0-indexed
                      }}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handleLimitChange}
                    />
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </DashboardLayout>
  )
}

export default Default
